import type { UserInfoUpdateRequestAPI } from './ApiTypes';

interface BuildUserInfoChangesInput {
  initialName: string;
  initialPhone: string;
  nextName: string;
  nextPhone: string;
}

/**
 * Builds the `changes` payload for POST /account/update.
 * - Omits keys for fields that did not change.
 * - Sends `phone_number` already normalized to E.164 BR.
 * - Clearing the phone sends `null`, never `""`: the API contract is tri-state
 *   (absent = keep, `null` = clear, E.164 string = update) and an empty string
 *   fails the E.164 validation with 400.
 */
export const buildUserInfoChanges = ({ initialName, initialPhone, nextName, nextPhone }: BuildUserInfoChangesInput): UserInfoUpdateRequestAPI['changes'] => {
  const changes: UserInfoUpdateRequestAPI['changes'] = {};
  if (nextName !== initialName) changes.fullname = nextName;
  if (nextPhone !== initialPhone) changes.phone_number = nextPhone || null;
  return changes;
};
